import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { CreateNpsForm, UpdateNpsForm, FiltersNpsForms } from '@/Network/Types/Requests/NpsRequests'
import { NpsFormResponse, ListNpsFormsResponse } from '@/Network/Types/Responses/NpsResponses'

export default class NpsFormService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/forms'
  }

  async create(payload: CreateNpsForm): Promise<NpsFormResponse> {
    try {
      const response = await request.post<NpsFormResponse>(this.getCompletePath(), payload)
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível criar a enquete.')
    }
  }

  async update(formId: number, payload: UpdateNpsForm): Promise<NpsFormResponse> {
    try {
      const response = await request.put<NpsFormResponse>(
        `${this.getCompletePath()}/${formId}`,
        payload
      )
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível salvar a enquete.')
    }
  }

  async getById(formId: number): Promise<NpsFormResponse> {
    try {
      const response = await request.get<NpsFormResponse>(`${this.getCompletePath()}/${formId}`)
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar a enquete.')
    }
  }

  async toggleActive(formId: number, companyId: number): Promise<NpsFormResponse> {
    try {
      const response = await request.patch(
        `${this.getCompletePath()}/${formId}/toggle-active?companyId=${companyId}`,
        {}
      )
      return response.data as NpsFormResponse
    } catch (e) {
      throw this.handleError(e, 'Não foi possível alterar o status da enquete.')
    }
  }

  async delete(formId: number): Promise<void> {
    try {
      await request.delete(`${this.getCompletePath()}/${formId}`)
    } catch (e) {
      throw this.handleError(e, 'Não foi possível excluir a enquete.')
    }
  }

  async list(filters?: FiltersNpsForms): Promise<ListNpsFormsResponse> {
    try {
      const { data } = await request.get<ListNpsFormsResponse>(this.getCompletePath(), filters)
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as enquetes.')
    }
  }
}
